<template>
  <div class="section-asiento">

    <v-dialog v-if="showPaymentAccountDialog" v-model="showPaymentAccountDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline title-color">Asiento de Pago Manual</v-card-title>
        <v-card-text class="mt-4">
          <doc-text-field
            kind="account"
            v-model="manualAccount"
            :rules="accountRules"
            label="Cuenta de Pago / Cobro (Manual)" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" outlined text class="primary-border" @click="noCreatePaymentLine()">Cancelar</v-btn>
          <v-btn color="white" text class="primary-bckground" @click="createPaymentLine()" >Crear</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <MessagePopup v-if="show_message" :message="message" :show_message="show_message" @close-message="closeMessage"></MessagePopup>

    <!-- Plan Details Dialog -->
    <v-dialog v-model="showPlanDetailDialog" max-width="600" @click:outside="closePlanDetails">
      <v-card>
        <v-card-title class="headline primary white--text">
          {{ selectedPlanTitle }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closePlanDetails">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <div v-if="selectedPlan">
            <div class="mb-3">
              <strong>Plan:</strong> {{ selectedPlan.name }} ({{ selectedPlan.code }})
            </div>
            <div v-if="selectedPlan.total_amount" class="mb-3">
              <strong>Total:</strong> {{ formatAmount(selectedPlan.total_amount) }} €
            </div>
            <v-divider class="mb-3"></v-divider>
            <div class="plan-tree">
              <div v-if="planTree.length === 0" class="text-center grey--text">
                No hay niveles seleccionados
              </div>
              <div v-else>
                <div v-for="(parent, index) in planTree" :key="index" class="tree-parent mb-3">
                  <div class="tree-parent-name font-weight-bold mb-1">
                    <v-icon small color="primary" class="mr-1">mdi-chevron-right</v-icon>
                    {{ parent.code }} - {{ parent.name }}
                    <span v-if="parent.amount !== null" class="ml-2 grey--text">
                      ({{ formatAmount(parent.amount) }} €)
                    </span>
                  </div>
                  <div v-if="parent.children && parent.children.length > 0" class="tree-children ml-6">
                    <div v-for="(child, childIndex) in parent.children" :key="childIndex" class="tree-child">
                      <v-icon small class="mr-1">mdi-circle-small</v-icon>
                      {{ child.code }} - {{ child.name }}
                      <span v-if="child.amount !== null" class="ml-2 primary--text font-weight-medium">
                        {{ formatAmount(child.amount) }} €
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-toolbar clipped class="toolbar-asiento">
      <AppIcon src="/invoices/table_view.svg" :size="29" class="divider-img ml-2" />
      <!-- Establecemos los TABS -->
      <v-tabs v-model="tab">
        <v-tab @click="set_active_tab('account_move')" v-if="currentDoc.forced_move">Asiento <span class="font-weight-regular"> &nbsp;(Editado)</span></v-tab>
        <v-tab @click="set_active_tab('account_move')" v-else >Asiento </v-tab>
        <v-tab @click="set_active_tab('paid_move')" 
          :disabled="(paid_account_move_lines && paid_account_move_lines.length == 0) && !currentDoc.forced_move"
          v-if="feature_payment_move"
        >Asiento de Pago</v-tab>
      </v-tabs>
      <v-spacer/>
      <template cols="1" align="left" 
          v-if="currentDoc.forced_move && ['error_creating_moves', 'error_validating_moves', 'pending_review', 'error_account_connector'].includes(currentDoc.state)">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                  class="mr-2 btn-rounded-toolbar" 
                  rounded                    
                  @click="reverse_amounts_in_lines()"
                  v-bind="attrs"
                  v-on="on"                  
                >
                  <img src="/invoices/change_columns.png" width="11" height="11">
              </v-btn>
              </template>
              <span>Cambiar Debe - Haber</span>
          </v-tooltip>
          
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                rounded
                class="mr-2 btn-rounded-toolbar"                    
                @click="change_sign_amounts_in_lines()"
                v-bind="attrs"
                v-on="on"
              >
                <img src="/invoices/change_sign.png" width="11" height="11">  
              </v-btn>
            </template>
            <span>Cambiar Signo</span>
          </v-tooltip>
      </template>
      <template 
      v-if="account_move">
        <v-btn v-if="showPaymentAccountDialogButton" class="mr-2"
          :loading="loading_doc_account_moves" color="primary" @click="openShowPaymentAccountDialog()"
          :disabled="currentDoc.state=='pending_connect' || dirty || isWaitingFlow"
        >
          Asiento de Pago Manual
        </v-btn>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              v-if="!currentDoc.forced_move && !['done','done_manually','done_with_warning','pending_connect'].includes(currentDoc.state)" 
              class="mr-2 btn-rounded-toolbar"
              rounded
              :loading="loading_doc_account_moves"                 
              @click="enableDisableAccountMoveInputs();show_lines();show_modal_asiento()"
              :disabled="currentDoc.state=='pending_connect' || dirty || isWaitingFlow"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon vonce>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar asiento</span>
        </v-tooltip>
        <div v-if="got_feature('feature_show_popup_asientos')" class="mismaLinea">
          <v-btn 
          v-if="currentDoc.forced_move && !['done','done_manually','done_with_warning','pending_connect'].includes(currentDoc.state)" outlined color="primary" :loading="loading_doc_account_moves" @click="show_modal_asiento()"
          :disabled="currentDoc.state=='pending_connect'"
          class="mr-2 btn-rounded-toolbar"
          rounded
          >
          <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn 
            v-if="currentDoc.forced_move && !['done','done_manually','done_with_warning','pending_connect'].includes(currentDoc.state)" outlined color="primary" :loading="loading_doc_account_moves" @click="cancelEdit()"
            :disabled="currentDoc.state=='pending_connect'"
            class="btn-white-toolbar btn-white-toolbar-icon"            
          >
            Cancelar
          </v-btn>
        </div>
        <div v-else>
          <v-btn 
          v-if="currentDoc.forced_move && !['done','done_manually','done_with_warning','pending_connect'].includes(currentDoc.state)" outlined color="primary" :loading="loading_doc_account_moves" @click="cancelEdit()"
          :disabled="currentDoc.state=='pending_connect'"
          class="btn-white-toolbar btn-white-toolbar-icon"            
          >
          <v-icon left>mdi-pencil</v-icon>
            Cancelar
          </v-btn>
        </div>
      </template>

      <v-btn v-else
        alt="Asiento Manual"                      
        @click="clickForceMove()" 
        class="mr-2 btn-rounded-toolbar" 
        rounded
        :disabled="dirty || isWaitingFlow || currentDoc.state=='pending_connect' || !isValidDate(currentDoc.metadata['invoice_date']) || (currentDoc.companydb_gestion_cartera && !isValidDate(currentDoc.metadata['due_date']))">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
    </v-toolbar>

    <v-card
      v-if="account_move"
      flat
      width="100%"
      height="270"
      class="text-center pa-4 rounded-0"
    >
      <v-tabs-items v-model="tab">

        <v-tab-item>
          <v-row no-gutters class="sm2">
            <v-col cols="12" sm="6">
              <doc-text-field 
                v-if="account_move"
                regular
                color="primary" 
                label="Número"
                v-model="account_move.mov_number" 
                dense
                hide-details
                readonly
                cols="2"
                stylev2
                class="disable-text"
              ></doc-text-field>
            </v-col>
            <div v-if="balance" class="error--text pl-4 fs-12">{{'Descuadre: '+balance }}</div>
          </v-row>

          <v-data-table
            :headers="headers"
            :items="account_move_lines"
            hide-default-footer
            class="elevation-0 compact-table"
          >
    
            <template v-slot:item.account="{ item }">
              <v-tooltip 
                top 
                v-if="hasAccounts(item)" 
                :disabled="!hasAccounts(item)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" style="width: 100%;">
                    <DocTextField
                      label=""
                      :kind="got_feature('feature_accounts_master') ? 'account_am' : 'account'"
                      :required="true"
                      v-model="item.account"
                      :disabled="(disable_for_edit_Mode && !edit_only_accounts) || forcePayMoveEdit"
                      :items="got_feature('feature_accounts_master') ? accounts : []"
                      @get-values="getValues"
                      @reset-items="resetItems"
                    />
                  </div>
                </template>

                <span>{{ accountData.accounts[item.account] }}</span>
              </v-tooltip>

              <DocTextField
                v-else
                label=""
                :kind="got_feature('feature_accounts_master') ? 'account_am' : 'account'"
                :required="true"
                v-model="item.account"
                :disabled="(disable_for_edit_Mode && !edit_only_accounts) || forcePayMoveEdit"
                :items="got_feature('feature_accounts_master') ? accounts : []"
                @get-values="getValues"
                @reset-items="resetItems"
              />
            </template>

            <template v-slot:item.description="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" style="width: 100%;">
                    <DocTextField
                      label=""
                      v-model="item.description"
                      :required="true"
                      hide-details
                      :disabled="disable_for_edit_Mode || forcePayMoveEdit"
                    />
                  </div>
                </template>
                <span>{{ item.description }}</span>
              </v-tooltip>
            </template>

            <template v-slot:item.debit="{ item }">
              <DocTextField
                v-if="item.line_type == 'apunte'"
                label=""
                kind="number"
                :required="true"
                v-model="item.debit"
                :disabled="disable_for_edit_Mode || forcePayMoveEdit"
              />
            </template>

            <template v-slot:item.credit="{ item }">
              <DocTextField
                v-if="item.line_type == 'apunte'"
                label=""
                kind="number"
                :required="true"
                v-model="item.credit"
                :disabled="disable_for_edit_Mode || forcePayMoveEdit"
              />
            </template>

            <template v-slot:item.plan_1="{ item }">
              <div
                v-if="item.plan_1"
                @click="showPlanDetails(item.plan_1, 'Plan 1')"
                class="clickable-plan-field"
              >
                <span
                  class="plan-name-clickable"
                  :class="{ 'plan-error': (account_move_lines.indexOf(item) > -1
                      && screen_data.lines[account_move_lines.indexOf(item)]
                      && screen_data.lines[account_move_lines.indexOf(item)].plan_1)
                    ? screen_data.lines[account_move_lines.indexOf(item)].plan_1.ui_error
                    : false }"
                >
                  {{ item.plan_1.name }}
                </span>
              </div>
            </template>

            <template v-slot:item.plan_2="{ item }">
              <div
                v-if="item.plan_2"
                @click="showPlanDetails(item.plan_2, 'Plan 2')"
                class="clickable-plan-field"
              >
                <span
                  class="plan-name-clickable"
                  :class="{ 'plan-error': (account_move_lines.indexOf(item) > -1
                      && screen_data.lines[account_move_lines.indexOf(item)]
                      && screen_data.lines[account_move_lines.indexOf(item)].plan_2)
                    ? screen_data.lines[account_move_lines.indexOf(item)].plan_2.ui_error
                    : false }"
                >
                  {{ item.plan_2.name }}
                </span>
              </div>
            </template>

            <template v-slot:item.type_iva="{ item }">
              <DocTextField
                v-if="currentCompany"
                label=""
                v-model="item.type_iva"
                hide-details
                :required="requiredTypeIvaLine(item)"
                :disabled="disable_for_edit_Mode || forcePayMoveEdit"
              />
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn
                icon
                :disabled="disable_for_edit_Mode || forcePayMoveEdit"
                @click="deleteLineFromTable(item)"
              >
                <img src="/invoices/delete_row.png" />
              </v-btn>
            </template>

            <template v-slot:body.append>
              <tr class="total-row">
                <td></td>
                <td class="text-right">Total</td>
                <td>{{ totalDebit }}</td>
                <td>{{ totalCredit }}</td>
                <td></td>
                <td></td>
              </tr>
            </template>
          </v-data-table>

          <v-row no-gutters>
            <v-col cols="4" class="text-left custom_col_4_4 py-1">
              <template v-if="account_move">
                <v-btn 
                  v-if="!['done','done_manually','done_with_warning','pending_connect'].includes(currentDoc.state)"
                  :class="{
                    'btn-add-line-asiento': true,
                    'disable-text': disable_for_edit_Mode || forcePayMoveEdit,
                    'activate-text': !disable_for_edit_Mode && !forcePayMoveEdit
                  }"
                  @click="addLine"
                  outlined
                  dense
                  :disabled="disable_for_edit_Mode || forcePayMoveEdit"
                  >
                  <div 
                    :class="{
                      'disable-text': disable_for_edit_Mode || forcePayMoveEdit,
                      'activate-text': !disable_for_edit_Mode && !forcePayMoveEdit
                    }"
                  >
                    <v-icon left
                      :style="disable_for_edit_Mode || forcePayMoveEdit ? 'color: #6D6D6D !important;' : 'font-weight: 400 !important;'"
                    >
                      mdi-plus
                    </v-icon>
                    Añadir línea
                  </div>
                </v-btn>
              </template>
            </v-col>
            <v-col cols="1" class="table-aux " />
            <v-col cols="1" class="custom_col_0_6"/>
          </v-row>

        </v-tab-item>
      
        <v-tab-item v-if="!paid_account_move_lines || paid_account_move_lines.length == 0">
            <v-row>
              <v-col cols="4" class="pt-0 pb-1 text-left" v-if="account_move">
                <v-btn 
                  v-if="!['done','done_manually','done_with_warning','pending_connect'].includes(currentDoc.state)"
                  :class="{
                    'btn-add-line-asiento': true,
                    'disable-text': disable_for_edit_Mode,
                    'activate-text': !disable_for_edit_Mode
                  }"                 
                  :disabled="disable_for_edit_Mode"
                  @click="addPaidLine"
                  outlined
                  dense
                  >
                  <div 
                    :class="{
                      'disable-text': disable_for_edit_Mode,
                      'activate-text': !disable_for_edit_Mode
                    }"
                  >
                    <v-icon left
                      :style="disable_for_edit_Mode ? 'color: #6D6D6D !important;' : 'font-weight: 400 !important;'"
                    >
                      mdi-plus
                    </v-icon>
                    Añadir línea
                  </div>
                </v-btn>                  
              </v-col>
            </v-row>
            <v-alert prominent text type="success" class="fs-12">No se han creado Asientos del tipo indicado</v-alert>
        </v-tab-item>

        <v-tab-item v-if="paid_account_move_lines && paid_account_move_lines.length > 0">

          <v-row no-gutters>
            <v-col cols="12" sm="6">
              <doc-text-field
                v-if="paid_account_move"
                regular
                color="primary" 
                label="Número" 
                v-model="paid_account_move.mov_number" 
                dense
                hide-details
                readonly
                stylev2                  
              ></doc-text-field>
            </v-col>

            <div v-if="balancePaid" class="error--text pl-4 fs-12">{{'Descuadre: '+ balancePaid }}</div>
          </v-row>

          <v-row class="table-head-row mt-3" no-gutters>
            <v-col cols="2" class="text table-head custom_col_2_4">Cuenta</v-col>
            <v-col cols="4" class="table-head">Descripción</v-col>
            <v-col cols="2" class="table-head">Deber</v-col>
            <v-col cols="2" class="table-head">Haber</v-col>
            <v-col cols="1" class="table-head">T.Imp.</v-col>
            <v-col cols="1" class="table-right-head custom_col_0_6"></v-col>
          </v-row>

          <!-- Pintamos, aquí los movimientos relacionados -->
          <v-row   class="table-row" no-gutters v-for="(paid_move, index) in paid_account_move_lines" v-bind:key="index" align="center" justify="center">
            <v-col cols="2" class="table-head custom_col_2_4">
                <DocTextField
                  label="" 
                  :kind="got_feature('feature_accounts_master') ? 'account_am' : 'account'"
                  :required="true"
                  v-model="paid_move.account"
                  :class="{
                    invalid:currentDoc && !paid_move.account,
                    'disable-text': disable_for_edit_Mode,
                    'activate-text': !disable_for_edit_Mode
                  }"
                  :disabled="disable_for_edit_Mode"
                  :items="got_feature('feature_accounts_master') ? accounts : []"
                  @get-values="getValues"
                  @reset-items="resetItems"
                  class="activate-text"
                ></DocTextField>
              </v-col>           
              <v-col cols="4" class="table-head" style="border: 1px solid blue;">
                <DocTextField 
                  label="" 
                  v-model="paid_move.description" 
                  :required="true"
                  hide-details
                  :disabled="disable_for_edit_Mode"
                  class="activate-text"
                  :class="{
                    'disable-text': disable_for_edit_Mode,
                    'activate-text': !disable_for_edit_Mode
                  }"
                ></DocTextField>
              </v-col>
              <v-col cols="2" class="table-head" v-if="paid_move.line_type == 'apunte'" style="border: 1px solid blue;">
                <DocTextField
                  label="" 
                  kind="number"
                  :required="true"
                  v-model="paid_move.debit" 
                  :disabled="disable_for_edit_Mode"
                  class="activate-text"
                  :class="{
                    'disable-text': disable_for_edit_Mode,
                    'activate-text': !disable_for_edit_Mode
                  }"
                ></DocTextField>
              </v-col>
              <v-col cols="2" class="table-head" v-if="paid_move.line_type == 'apunte'" style="border: 1px solid blue;">
                <DocTextField
                  label="" 
                  kind="number"
                  :required="true"
                  v-model="paid_move.credit" 
                  :disabled="disable_for_edit_Mode"
                  class="activate-text"
                  :class="{
                    'disable-text': disable_for_edit_Mode,
                    'activate-text': !disable_for_edit_Mode
                  }"
                ></DocTextField>
                
              </v-col>
              <v-col cols="1" class="table-head" style="border: 1px solid blue;">
                <DocTextField 
                  v-if="currentCompany" 
                  label="" 
                  v-model="paid_move.type_iva"
                  hide-details
                  :required="requiredTypeIvaLine(paid_move)"
                  :disabled="disable_for_edit_Mode"
                  class="activate-text"
                  :class="{
                    'disable-text': disable_for_edit_Mode,
                    'activate-text': !disable_for_edit_Mode
                  }"
                ></DocTextField>
              </v-col>
              <v-col cols="1" class="table-right-head custom_col_0_6" style="border: 1px solid blue;">
                <v-btn icon color="primary" :disabled="disable_for_edit_Mode" @click="deletePaidLine(index)" 
                :class="{
                  'disable-text': disable_for_edit_Mode,
                  'activate-text': !disable_for_edit_Mode
                }"
                >
                  
                  <img src="/invoices/delete_row.png"/>
                </v-btn>
              </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="4" class="text-left custom_col_4_4 py-1">
              <template v-if="account_move">
                <v-btn 
                  v-if="!['done','done_manually','done_with_warning','pending_connect'].includes(currentDoc.state)"
                  class="btn-add-line-asiento"                  
                  :disabled="disable_for_edit_Mode"
                  @click="addPaidLine"
                  outlined
                  dense
                  >
                  <div 
                    :class="{
                      'disable-text': disable_for_edit_Mode,
                      'activate-text': !disable_for_edit_Mode
                    }"
                  >
                    <v-icon left
                      :style="disable_for_edit_Mode ? 'color: #6D6D6D !important;' : 'font-weight: 400 !important;'"
                    >
                      mdi-plus
                    </v-icon>
                    Añadir línea
                  </div>
                </v-btn>
              </template>
            </v-col>
            <v-col cols="2" class="total-cell-label pt-2 fs-12 pt-1 pr-2 text-center">Total</v-col>
            <v-col cols="2" class="py-1 pl-1"><div class="total-cell pr-2 text-right">{{ totalDebitPaid }}</div></v-col>
            <v-col cols="2" class="py-1 pl-1"><div class="total-cell pr-2 text-right">{{ totalCreditPaid }}</div></v-col>
            <v-col cols="1" class="table-aux "></v-col>
            <v-col cols="1"></v-col>
          </v-row>

        </v-tab-item>

      </v-tabs-items>

    </v-card>

  </div>
</template>

<script>
import DocTextField from "./DocTextField.vue"
import MessagePopup from "./MessagePopup.vue";
import { mapGetters,mapActions, mapState, mapMutations} from "vuex"
import { createHelpers ,mapFields} from 'vuex-map-fields'
import {round, isValidDate} from '../utils'
import { vuexPrefix } from "../store/vuex_utils";
import { validateAccount } from "../utils/account_validation"
import {evaluate} from 'mathjs'
import { canEditAccountMove, canEditAccountsOnly } from "../modules/invoices/domain/Invoice"
import { VueFeatureRepository } from "../modules/shared/infra/FeatureRepository"
import { AccountQuery } from '@/modules/accounts/app/AccountQuery'
import { ApiAccountRepo } from "@/modules/accounts/infra/ApiAccountRepo";
import { VueAnalyticPlanEditorScreenData } from "@/modules/analitic_accounting/infra/VueAnalyticsPlanEditorScreenData";
import { AnalyticPlanEditorComponent } from "@/modules/analitic_accounting/application/AnalyticsPlanEditorComponent";
import { ApiCompanyRepository } from "@/modules/analitic_accounting/infra/ApiCompanyRepository"


const { mapMultiRowFields } = createHelpers({
  getterType: 'documents/getAccountMoveField',
  mutationType: 'documents/updateAccountMoveField',
});

export default {
      name:'AccountMoveV2',
      data(){
        const screen_data = new VueAnalyticPlanEditorScreenData();
        return {
          accountData: {
            accounts: {}
          },
          loading_doc_account_moves: false,
          tab: 0,
          active_tab: 'account_move',
          showPaymentAccountDialog: false,
          manualAccount: 0,
          message: '',
          show_message: false,
          disable_for_edit_Mode: true,
          edit_only_accounts: false,
          showPlanDetailDialog: false,
          selectedPlan: null,
          selectedPlanTitle: '',
          planTree: [],
          headers: [
            { text: 'Cuenta', value: 'account', sortable: false },
            { text: 'Descripción', value: 'description', sortable: false },
            { text: 'Debe', value: 'debit', sortable: false },
            { text: 'Haber', value: 'credit', sortable: false },
            { text: 'T.Imp.', value: 'type_iva', sortable: false },
            { text: '', value: 'actions', sortable: false }
          ],
          screen_data: screen_data,
        }
      },
      components:{
        DocTextField,
        MessagePopup,
      },
      computed:{
        ...mapGetters({
          currentDoc: 'documents/currentDocument',
          inRotationMode: 'documents/inRotationMode',
          dirty: 'documents/dirty',
          isWaitingFlow: "documents/isWaitingFlow",
          got_feature:'got_feature',
          userData: 'me/userData',
          min_footer: 'documents/min_footer',
          footer_height: 'documents/footer_height'
        }),
        ...mapState([
          'currentCompany'
        ]),
        account_move(){
          return (this.currentDoc && this.currentDoc.accountMoves.length)?this.currentDoc.accountMoves[0]:undefined
        },
        ...mapMultiRowFields(['account_move_lines', 'paid_account_move_lines']),
        ...mapFields('me',vuexPrefix('',['feature_payment_move'],'userData.available_features.')),
        ...mapFields('cru', ['accounts']),
        totalDebit(){
          try{
            if(this.account_move){
              return round(this.account_move_lines.map(x=>x.debit).reduce((x,y)=>this.num(x)+this.num(y),0))
            }
          }catch(err){
            console.error(err)
          }
          return 0
        },
        totalCredit(){
          try{
            if(this.account_move){
              return round(this.account_move_lines.map(x=>x.credit).reduce((x,y)=>this.num(x)+this.num(y),0))
            }
          }catch(err){
            console.error(err)
          }
          return 0
        },
        balance(){
          return round(this.totalDebit-this.totalCredit)
        },
        balancePaid(){
          return round(this.totalDebitPaid-this.totalCreditPaid)
        },
        paid_account_move(){
          return (this.currentDoc && this.currentDoc.accountMoves.length
            && this.currentDoc.accountMoves[0].paid_account_move && this.currentDoc.accountMoves[0].paid_account_move.length
          )
            ? this.currentDoc.accountMoves[0].paid_account_move[0] : undefined
        },
        paid_account_move_lines(){
          try
            {
              return (this.currentDoc && this.currentDoc.accountMoves.length
                && this.currentDoc.accountMoves[0].paid_account_move
                && this.currentDoc.accountMoves[0].paid_account_move.length > 0
                && this.currentDoc.accountMoves[0].paid_account_move[0].account_move_lines
                ) ? this.currentDoc.accountMoves[0].paid_account_move[0].account_move_lines : []
            } catch(err){
              console.error(err)
            }
          return undefined
        },
        totalCreditPaid(){
          try
          {
            if(this.paid_account_move_lines) {
              return round(this.paid_account_move_lines.map(x => x.credit).reduce((x,y) => this.num(x) + this.num(y),0))
            }
          } catch(err) {
            console.error(err)
          }
          return 0
        },
        totalDebitPaid(){
          try{
            if(this.paid_account_move_lines){
              return round(this.paid_account_move_lines.map(x => x.debit).reduce((x,y)=> this.num(x) + this.num(y),0))
            }
          }catch(err){
            console.error(err)
          }
          return 0
        },
        accountRules() {
          return [
            (v) => !v ||  validateAccount(v) || 'La cuenta debe contener únicamente dígitos'
          ]
        },
        showPaymentAccountDialogButton() {
          return !this.currentDoc.forced_move
            && (
              this.currentDoc.kind == 'in_invoice'
                && this.currentDoc.supplierdb_info && (
                  this.currentDoc.supplierdb_info.automatic_payment_account=='m' 
                  || (this.currentDoc.supplierdb_info.automatic_payment_account=='na' && this.currentCompany && this.currentCompany.automatic_payment_account=='m'))
              ||
              this.currentDoc.kind == 'out_invoice'
                && this.currentDoc.customerdb_info &&  (
                  this.currentDoc.customerdb_info.automatic_charge_account=='m' 
                || (this.currentDoc.customerdb_info.automatic_charge_account=='na' && this.currentCompany && this.currentCompany.automatic_charge_account=='m'))
            )
            && (!this.paid_account_move_lines || this.paid_account_move_lines.length == 0)
        },
        forcePayMoveEdit() {
          if(this.currentDoc.prorate && this.got_feature('feature_editar_asiento_pago')) {
            return true
          }
          return false
        },
      },
      created() {
        this.accounts = [];
        this.$root.$on('close-modal', this.handleCloseModalFromGrandchild);

      },
      methods:{
        hasAccounts(item) {
          return this.accountData &&
                this.accountData.accounts &&
                Object.keys(this.accountData.accounts).includes(item.account);
        },
        deleteLineFromTable(item) {
          const index = this.account_move_lines.findIndex(line => line.id === item.id)
          if (index !== -1) {
            this.deleteLine(index)
          } else {
            console.warn(`Cannot delete without "feature_show_popup_asientos":`, item)
          }
        },
        num(x){
          if (x==='') {
            return 0;
          }else{
            return evaluate(x);
          }

        },
        ...mapMutations({
          addLine:'documents/addLine', 
          addPaidLine: 'documents/addPaidLine',
          deleteLine:'documents/deleteLine',
          deletePaidLine: 'documents/deletePaidLine',
          forceMove: "documents/forceMove",
        }),
        ...mapActions({
          setForcedMove: "documents/setForcedMove",
          fetchDocumentMetadata: "documents/fetchDocumentMetadata",
          continueFlow: "documents/continueFlow",
          cancelEditFlow: "documents/cancelEditFlow",
          saveAccountMoves: "documents/saveAccountMoves",
          createManualPaymentMoves: "documents/createManualPaymentMoves",
          showAccountMoveFooter: "documents/showAccountMoveFooter",
          hideAccountMoveFooter: "documents/hideAccountMoveFooter",
          initAccountMoveFooter: "documents/initAccountMoveFooter"
        }),
        ...mapActions("cru", ['getAccounts']),
        show_modal_asiento(){
          if(this.got_feature("feature_show_popup_asientos")){

            this.currentDoc.forced_move = true;
            this.$modal.show('modal-asiento');
          }
          // else{
          //   this.disable_for_edit_Mode = false;
          // }
        },
        async handleCloseModalFromGrandchild(value) {
          console.log("blackraven - AccountMoveV2.ts - handleCloseModalFromGrandchild: ", this.account_move_lines);
          if (this.got_feature("feature_show_popup_asientos")) {
            this.disable_for_edit_Mode = true;
          }
          if(this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.value==='sage_addon' && this.got_feature('feature_analytic_lines')) {
            await this.analytic_plans_component.mountEditorComponent(this.currentDoc.companydb, this.account_move_lines);
          }
        
        },
        showMessage(m){
          this.message=m;
          this.show_message=true;
        },
        closeMessage(){
          this.show_message=false;
        },
        showPlanDetails(plan, title) {
          this.selectedPlan = plan;
          this.selectedPlanTitle = title;
          this.planTree = this.buildPlanTree(plan);
          this.showPlanDetailDialog = true;
        },
        closePlanDetails() {
          this.showPlanDetailDialog = false;
          this.selectedPlan = null;
          this.selectedPlanTitle = '';
          this.planTree = [];
        },
        buildPlanTree(plan) {
          if (!plan || !plan.levels || plan.levels.length === 0) {
            return [];
          }

          const tree = [];

          plan.levels.forEach(parent => {
            const node = {
              code: parent.code,
              name: parent.name,
              amount: parent.amount,
              children: []
            };

            // Add visible children
            if (parent.levels && parent.levels.length > 0) {
              parent.levels.forEach(child => {
                if (child.ui_visible !== false) {
                  node.children.push({
                    code: child.code,
                    name: child.name,
                    amount: child.amount
                  });
                }
              });
            }

            // Only add parent if it has visible children or is standalone
            if (node.children.length > 0 || parent.ui_visible !== false) {
              tree.push(node);
            }
          });

          return tree;
        },
        formatAmount(amount) {
          if (amount === null || amount === undefined) {
            return '0.00';
          }
          return Number(amount).toFixed(2);
        },
        change_sign_amounts_in_lines(){
          this.currentDoc.accountMoves.forEach((account_move) => {
            account_move.account_move_lines.forEach((line) => {
              line.credit = line.credit*(-1)
              line.debit = line.debit*(-1)
            })
          })
        },
        reverse_amounts_in_lines(){
          this.currentDoc.accountMoves.forEach((account_move) => {
            account_move.account_move_lines.forEach((line) => {
              let aux = line.credit
              line.credit = line.debit
              line.debit = aux
            })
          })
        },
        enableAccountMoveInputs() {
          this.disable_for_edit_Mode = false;
          this.loading_doc_account_moves = true;
          if(!this.got_feature("feature_show_popup_asientos")){
            this.setForcedMove(!this.currentDoc.forced_move);
          }
          this.fetchDocumentMetadata({ id: this.currentDoc.id }).then(() => {
            if(!this.account_move){
              this.hide_lines()
            }
            this.loading_doc_account_moves = false;
          });
        },
        enableDisableAccountMoveInputs() {
          this.disable_for_edit_Mode = true;
          this.edit_only_accounts = false;
          let feature_repo = new VueFeatureRepository(this.got_feature)
          let message = canEditAccountMove(this.currentDoc,this.userData,feature_repo) // if can edit returns '' and  error message if not
          
          if (message && this.currentDoc.static_invoice) {
            let accountsOnlyMessage = canEditAccountsOnly(this.currentDoc, this.userData, feature_repo);
            if (!accountsOnlyMessage) {
              this.edit_only_accounts = true;
              this.loading_doc_account_moves = true;
              if(!this.got_feature("feature_show_popup_asientos")){
                this.setForcedMove(true);
              }
              this.fetchDocumentMetadata({ id: this.currentDoc.id }).then(() => {
                if(!this.account_move){
                  this.hide_lines()
                }
                this.loading_doc_account_moves = false;
              });
              return;
            }
          }
          
          if (message){
            if(this.forcePayMoveEdit) {
              this.enableAccountMoveInputs();
              if(!this.got_feature("feature_show_popup_asientos")){
                this.showMessage(message);
              }
            } else {
              this.showMessage(message);
            }
          } else {
            this.enableAccountMoveInputs()
          }
        },
        start_check_async_job_state(id){
          this.check_async_job_state(id)
        },
        check_async_job_state(id){
          if(id==this.$store.state.documents.document.id.toString()){
              this.fetchDocumentMetadata({ id: this.$store.state.documents.document.id }).then(() => {
              if(['pending','running'].includes(this.$store.state.documents.document.async_job_state)){
                setTimeout(()=>this.check_async_job_state(this.$store.state.documents.document.id),3000)
              }
              else{
                if(!this.account_move){
                  this.hide_lines()
                }
                else{
                  this.show_lines()
                }
              }
            })
          }
          
        },
        clickForceMove() {
          let feature_repo = new VueFeatureRepository(this.got_feature)
          let message = canEditAccountMove(this.currentDoc,this.userData,feature_repo) // if can edit returns '' and  error message if not
          if (message){
            this.showMessage(message);
          } else {
            this.loading_doc_account_moves = true;
            this.setForcedMove(true);
            this.forceMove()
            this.saveAccountMoves()
            this.loading_doc_account_moves = false;
            this.show_lines()
          }
        },
        cancelEdit() {
          this.loading_doc_account_moves = true;
          this.disable_for_edit_Mode = true;
          this.setForcedMove(false);
          this.hide_lines()
          this.cancelEditFlow().then(() => {
            if(!this.account_move){
              this.hide_lines()
            }
            else{
              this.show_lines()
            }
            if(['pending','running'].includes(this.currentDoc.async_job_state)){
              setTimeout(()=>this.start_check_async_job_state(this.currentDoc.id),3000)
            }
            this.loading_doc_account_moves = false;
          });
          
        },
        hide_lines(){
          this.hideAccountMoveFooter();
        },
        show_lines(){
          this.showAccountMoveFooter();
        },
        isValidDate(d_str){
          return isValidDate(d_str)
        },
        set_active_tab(tab_value){
          this.active_tab = tab_value
        },
        openShowPaymentAccountDialog() {
          this.showPaymentAccountDialog = true
        },
        noCreatePaymentLine() {            
          this.showPaymentAccountDialog = false
        },
        createPaymentLine() {
          try {
            this.createManualPaymentMoves({
              "document_id" : this.currentDoc.id,
              "account" : this.manualAccount
            }).then(() => {}
                //setTimeout(() => this.check_async_job_state(this.$store.state.documents.document.id), 2000)
                )

            this.showPaymentAccountDialog = false
          } catch(err) {
            console.error(err)
          }            
        },
        getValues(params) {
          this.getAccounts(params).then(() => {});
        },
        resetItems(params) {
          this.accounts = params;
        },
        requiredTypeIvaLine(line) {
          return this.currentDoc && line && line.account && (line.account.startsWith('472') || line.account.startsWith('477')) && !line.type_iva && !((this.currentDoc.iva_parcial || this.currentDoc.gasto_iva_parcial) && this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.params.hasOwnProperty('allow_account_exc_expens_lines_no_IVA') && line.account.startsWith(this.currentCompany.companydb_type.params['allow_account_exc_expens_lines_no_IVA']));
        },
        async fetchAndMapAccounts({
          accountMove,
          accountMoveLines,
          currentCompany,
          accountData,
          setAccountData
        }) {

          if (!accountMove || !currentCompany) {
            console.warn('accountMove or currentCompany is empty', {
              accountMove,
              currentCompany
            });
            return;
          }

          const validAccountNumbers = accountMoveLines
            .map(line => line.account)
            .filter(Boolean);

          if (!validAccountNumbers.length) {
            console.warn('No valid accounts found in accountMoveLines:', accountMoveLines);
            return;
          }

          const repo = new ApiAccountRepo();
          const query = new AccountQuery(repo);

          try {
            const fetchedAccounts = await query.findByAccountNumbers(validAccountNumbers, currentCompany.id);
            const mappedAccounts = query.formatAccountLabelMap(fetchedAccounts);
            setAccountData(accountData, 'accounts', mappedAccounts);
          } catch (error) {
            console.error('Error executing query:', error);
          }
        }
      },
      async mounted(){

        this.initAccountMoveFooter(this.account_move);

        if(this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.value==='sage_addon' && this.got_feature('feature_analytic_lines')) {
          let company_repo = new ApiCompanyRepository()
          this.analytic_plans_component = new AnalyticPlanEditorComponent(company_repo, this.screen_data)
          await this.analytic_plans_component.mountEditorComponent(this.currentDoc.companydb, this.account_move_lines)
        
          
          const newHeaders = [
            { text: 'Plan 1', value: 'plan_1', width: '10%'},
            { text: 'Plan 2', value: 'plan_2', width: '10%'},
          ];
          const index = this.headers.findIndex(h => h.value === 'actions');
          this.headers.splice(index, 0, ...newHeaders);
        }

        await this.fetchAndMapAccounts({
            accountMove: this.account_move,
            accountMoveLines: this.account_move_lines,
            currentCompany: this.currentCompany,
            accountData: this.accountData,
            setAccountData: this.$set
        });
      }
    }
</script>

<style scoped>
    .toolbar-asiento {
       background-color: var(--v-primaryLighter-base) !important;
       height: 40px !important;
       box-shadow: none !important;       
     }
     .toolbar-asiento .divider-img {
        width:24px;
        height:24px;
        align-self:center;
        margin-right:10px;
     }
     .toolbar-asiento .btn-white-toolbar {
       background-color: white;
       padding: 0px 5px !important;
       border-radius: 15px;
       height: 24px !important;
       text-transform: capitalize !important;
       font-weight: 400;
     }
     .toolbar-asiento .btn-white-toolbar:hover {
       background-color: #eae2f5;
     }
     .toolbar-asiento .v-btn {
       box-shadow: none;
     }
     .toolbar-asiento .btn-rounded-toolbar {
       width: 24px !important;
       height: 24px !important;
       background-color:var(--v-primary-base) !important;
     }
     .toolbar-asiento .btn-rounded-toolbar:hover {
       background-color: #7f6797 !important;
     }
     .toolbar-asiento .btn-rounded-toolbar .v-icon {
       font-size:14px !important;
       color:white;
     }
 
     .toolbar-asiento .btn-white-toolbar-icon .v-icon {
       font-size:12px !important;
       margin-left: -6px;
       margin-right: 3px;
       border-top-left-radius: 12px;
       border-bottom-left-radius: 12px;
       height: 24px;
       width: 24px;
       color: white;      
       background-color: var(--v-primary-base);      
     }
     .toolbar-asiento .btn-square {
       border-radius:0px;
     }
     
     .toolbar-asiento >>> .v-toolbar__content{
         padding: 4px 5px;
         height: 40px !important;
     }
     .toolbar-asiento .v-tabs {
       margin-left: -4px;
     }
     .toolbar-asiento .v-tab{
       font-size:12px;
       padding: 0 6px;
       letter-spacing: normal;
       min-width: 103px;
       font-weight: 600;
     }
     .toolbar-asiento .v-tab.v-tab--active{
       color:var(--v-primaryDark-base);
     }
     .toolbar-asiento .v-tab:not(.v-tab--active){
       color:var(--v-primaryDark-base) !important;
     }
     .toolbar-asiento >>> .v-slide-group__next, 
     .toolbar-asiento >>> .v-slide-group__prev {
       min-width: 0px !important;
     }
     .toolbar-asiento >>> .v-btn {
       min-width: 0px;
       height: 20px;
       padding:0px;
     }
     .toolbar-asiento >>> .v-btn .v-btn__content {
       font-size:10px;
       letter-spacing: normal;
     }
     .toolbar-asiento >>> .v-btn .v-btn__content .v-icon {
       font-size:18px;
     }
 
   .btn-plus-asiento {
     height: 20px !important;
     border-radius: 0px !important;
     box-shadow: none !important;
     background-color: #56565B !important;
     color:white !important;
     padding:0px !important;
     min-width: 0px !important;
   }
   .btn-plus-line-table {
     height: 100% !important;
     width: 100%;
     border-radius: 0px !important;
     box-shadow: none !important;
     background-color: var(--v-primary-base) !important;
     color:white !important;
     padding:0px !important;
     min-width: 0px !important;
   }
   .btn-plus-asiento .v-icon,
   .btn-plus-line-table .v-icon {
     font-size:18px;
   }

  .btn-add-line-asiento {
    height: 23px !important;
    border-radius:2px;
    text-transform: none;
    border-color: #B0B0B0;
    font-size:12px;
    font-weight: 400;
    letter-spacing:normal;
   }
  
  .table-head >>> div > .v-text-field {
    margin-top: 0px;
  }
  .table-left-head >>> div > .v-text-field {
    margin-top: 0px;
  }
  .table-head >>> div > .v-text-field > .v-input__control > .v-input__slot {
    height: 20px;
    font-size:12px;
  }
  .table-head >>> .v-text-field input{
    margin-right:5px !important;
    margin-left:5px !important;
  }
  .table-left-head >>> div > .v-text-field > .v-input__control > .v-input__slot {
    height: 20px;
    font-size:10px;
  }
  .table-right-head .v-btn--icon {
    width: 19px;
    height: 19px;
  }
  .table-right-head .v-btn--icon .v-icon {
    font-size:16px;
    width: 19px;
    height: 19px;
    color:#565656;
  }

  .fs-12 {
     font-size: 12px;
  }

  /* Clickable plan field */
  .clickable-plan-field {
    cursor: pointer;
  }

  .plan-name-clickable {
    color: var(--v-primary-base);
    font-weight: 500;
    transition: all 0.2s ease;
    display: inline-block;
    padding-bottom: 2px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    width: 100%;
  }

  .clickable-plan-field:hover .plan-name-clickable {
    color: var(--v-primaryDark-base);
    border-bottom-color: rgba(0, 0, 0, 0.87);
  }

  .plan-error {
    color: #ff9898 !important;
    border-bottom-color: #ff9898 !important;
  }

  /* Plan details dialog styles */
  .plan-tree {
    max-height: 400px;
    overflow-y: auto;
  }

  .tree-parent {
    line-height: 1.8;
  }

  .tree-parent-name {
    display: flex;
    align-items: center;
    color: var(--v-primaryDark-base);
    font-size: 14px;
  }

  .tree-children {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .tree-child {
    display: flex;
    align-items: center;
    color: #5a5a5a;
    font-size: 13px;
    line-height: 1.6;
  }

</style>

<style lang="scss" scoped>
    .primary-bckground {
        background-color: var(--v-primary-base);
    }
    .primary-border {
        border-color: var(--v-primary-base) !important;
    }
    .table-head {
        border-left-style:solid;
        border-right-style:solid;
        border-color:#D9D9D9;
        border-width: thin;
    }
    .table-right-head {
        border-right-style:solid;
        border-color:#D9D9D9;
        border-width: thin;
    }
    .table-left-head {
        border-left-style:solid;
        border-color:#D9D9D9;
        border-width: thin;
    }
    .total-cell-label {
      font-size:12px;
      font-weight: 600;
      color: var(--v-primaryDark-base);
    }
    .total-cell {
      box-sizing: border-box;
      border:1px solid #00000061;
      line-height: 23px;
      border-radius: 2px;
      font-size: 12px;
      padding-top:2px;
    }
    .total-center-cell {      
      border-bottom-style: solid;
      border-right-style: solid;
      border-left-style: solid;
      border-color: var(--v-primary-base);
      border-width: thin;
    }
    .total-right-cell {
      border-bottom-style: solid;
      border-right-style: solid;
      border-left-style: solid;
      border-color: var(--v-primary-base);
      border-width: thin;

    }
    .total-left-cell {
      border-bottom-style: solid;
      border-left-style: solid;
      border-right-style: solid;
      border-color: var(--v-primary-base);
      border-width: thin;
    }
    .table-head-row {
        border-right-style: solid;
        border-left-style: solid;
        border-bottom-style: solid;
        border-top-style: solid;
        border-color: #D9D9D9;
        border-width: thin;
        font-size:12px;
        background-color: #D9D9D9;
        color:#6D6D6D;
        font-weight: bold;
        line-height: 30px;
    }
    .table-row{
        border-right-style: solid;
        border-left-style: solid;
        border-bottom-style: solid;
        border-color: #D9D9D9;
        border-width: thin;
        line-height: 21px;
    }
    .table-aux{
      border-color:var(--v-primary-base);
      border-width: thin;
    }
    .footer {
      z-index: 101;
      max-height: 75%;
    }
    .custom_col_2_4 {
      max-width: 19.99999%;
      flex-basis:19.99999%;
    }
    .custom_col_4_4 {
      max-width: 36.66666%;
      flex-basis:36.66666%;
    }
    .custom_col_0_6 {
      max-width: 5%;
      flex-basis: 5%;
    }
    .mismaLinea {
      display: flex;
      align-items: center;
    }
</style>

<style>
.compact-table {
  margin-top: 16px;
  border: 1px solid #B0B0B0;
  border-radius: 2px;
  overflow: hidden;
  width: 100%;
  table-layout: auto;
}

.compact-table .v-data-table__wrapper td {
  padding: 2px 4px !important;
  height: 32px !important;
  vertical-align: middle !important;
  font-size: 12px !important;
  border-bottom: none !important;
  outline: none !important;
}

.compact-table .v-data-table-header th {
  font-size: 12px;
  height: 32px !important;
  text-align: center !important;
  vertical-align: middle !important;
  white-space: nowrap !important;
  background-color: #E5E5E5 !important;
}

/* Alinear derecha inputs Debe, Haber, T.Imp. */
.compact-table .v-data-table__wrapper td:nth-child(3) .v-input input,
.compact-table .v-data-table__wrapper td:nth-child(4) .v-input input,
.compact-table .v-data-table__wrapper td:nth-child(5) .v-input input {
  text-align: right !important;
  margin-right: 0 !important;
}

/* Alinear derecha contenido total Debe, Haber, T.Imp. */
.total-row td:nth-child(3),
.total-row td:nth-child(4),
.total-row td:nth-child(5) {
  text-align: right !important;
  padding-right: 10px !important;
}

/* Acciones */
.compact-table .v-data-table-header th:nth-child(6),
.compact-table .v-data-table__wrapper td:nth-child(6) {
   min-width: 40px !important;
}

.compact-table .v-data-table__wrapper td .v-input input {
  color: #6D6D6D !important;
}

.compact-table .v-data-table__wrapper td .v-input {
  margin: 0 !important;
  width: 100% !important;
  border-bottom: 1px solid #B0B0B0 !important; 
  border-radius: 0 !important;
}

.compact-table .v-data-table__wrapper td .v-text-field::before,
.compact-table .v-data-table__wrapper td .v-text-field::after {
  border-bottom: none !important;
}

.compact-table .v-data-table__wrapper td .v-text-field input {
  font-size: 12px !important;
  height: 28px !important;
}

.compact-table .v-btn {
  min-width: 0 !important;
  height: 20px !important;
}

.right-drawer-v2 {
  max-height: none !important;
  overflow: hidden !important;
}

.v-navigation-drawer__content .section-asiento .text-center {
  height: unset !important;
}

/* Total row estilos */
.total-row {
  background-color: var(--v-primaryLighter-base) !important;
}

.total-row td {
  background-color: inherit;
  font-weight: bold;
  color: #454545;
}


.total-row td:nth-child(3),
.total-row td:nth-child(4),
.total-row td:nth-child(5) {
  text-align: right !important;
  padding-right: 4px !important;
}

/* Cuenta */
.compact-table .v-data-table-header th:nth-child(1),
.compact-table .v-data-table__wrapper td:nth-child(1) {
  min-width: 130px !important;
  width: 1%; 
  white-space: nowrap;
}

/* Descripción */
.compact-table .v-data-table-header th:nth-child(2),
.compact-table .v-data-table__wrapper td:nth-child(2) {
  width: auto !important;
}

/* Debe, Haber */
.compact-table .v-data-table-header th:nth-child(3),
.compact-table .v-data-table-header th:nth-child(4),
.compact-table .v-data-table__wrapper td:nth-child(3),
.compact-table .v-data-table__wrapper td:nth-child(4) {
  min-width: 80px !important;
  width: 1%;
  white-space: nowrap;
}

/* T.Imp. */
.compact-table .v-data-table-header th:nth-child(5),
.compact-table .v-data-table__wrapper td:nth-child(5) {
  max-width: 54px !important;
  width: 6%;
}

/* Acciones */
.compact-table .v-data-table-header th:nth-child(6),
.compact-table .v-data-table__wrapper td:nth-child(6) {
  min-width: 40px !important;
  width: 1%;
}
</style>